import { Link } from "react-router-dom";

import { Button, Container, Typography, Box } from "@mui/material";

export const UnauthorizedPage = () => (
    <Container maxWidth="sm">
        <Box textAlign="center" py={5}>
            <Typography variant="h3" gutterBottom>
                403 - Unauthorized Access
            </Typography>
            <Typography variant="body1" color="textSecondary" gutterBottom>
                You do not have permission to view this page.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/"
            >
                Go to Homepage
            </Button>
        </Box>
    </Container>
);